import React from 'react';
import { Mail, MessageCircle, Phone, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#022C22] text-white py-12">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_vending-returns/artifacts/6zfihjrd_1000050582.png" 
              alt="LIVENEAT Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-[#F3F0E6]">
              Smart Vending Network<br />
              Eat well, live well
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-[#10B981] mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm text-[#F3F0E6]">
              <li className="flex items-start space-x-2">
                <Mail className="h-4 w-4 text-[#10B981] mt-0.5 flex-shrink-0" />
                <a href="mailto:liveneat.organic@gmail.com" className="hover:text-[#10B981] transition-colors break-all">
                  liveneat.organic@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MessageCircle className="h-4 w-4 text-[#10B981] mt-0.5 flex-shrink-0" />
                <div className="space-y-1">
                  <a href="https://wa.me/918595672124" target="_blank" rel="noopener noreferrer" className="hover:text-[#10B981] transition-colors block">
                    +91 8595672124
                  </a>
                  <a href="https://wa.me/917411515444" target="_blank" rel="noopener noreferrer" className="hover:text-[#10B981] transition-colors block">
                    +91 74115 15444
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <Linkedin className="h-4 w-4 text-[#10B981] mt-0.5 flex-shrink-0" />
                <a href="https://www.linkedin.com/in/anupam-prasad-a0a249388" target="_blank" rel="noopener noreferrer" className="hover:text-[#10B981] transition-colors">
                  Anupam Prasad (Founder)
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-[#10B981] mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-[#F3F0E6]">
              <li><a href="#overview" className="hover:text-[#10B981] transition-colors">Investment Overview</a></li>
              <li><a href="#calculator" className="hover:text-[#10B981] transition-colors">ROI Calculator</a></li>
              <li><a href="#returns" className="hover:text-[#10B981] transition-colors">Projected Returns</a></li>
              <li><a href="#contact" className="hover:text-[#10B981] transition-colors">Contact Us</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-[#10B981] mb-4">Investment Terms</h4>
            <ul className="space-y-2 text-sm text-[#F3F0E6]">
              <li>Returns: Performance-driven</li>
              <li>Contract: 12 months</li>
              <li>Payout: Monthly</li>
              <li>Exit: Renewal or settlement</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-[#F3F0E6] mb-4 md:mb-0">
              © {new Date().getFullYear()} LIVENEAT. All rights reserved.
            </p>
            <p className="text-xs text-[#4B5563]">
              Investment subject to terms & conditions. Returns are performance-based and not guaranteed.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
